import { render, staticRenderFns } from "./ztTab.vue?vue&type=template&id=f968b912&scoped=true&"
import script from "./ztTab.vue?vue&type=script&lang=js&"
export * from "./ztTab.vue?vue&type=script&lang=js&"
import style0 from "../../../../../src/styles/components/ztTab.css?vue&type=style&index=0&id=f968b912&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../admin/public/onboarding/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f968b912",
  null
  
)

export default component.exports